import React, { useState } from "react";
import { CheckSquare, X } from "lucide-react";

const hojeBR = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });

/* Barra do modo de seleção múltipla da aba Mídias: marcar obra concluída e alterar data em lote. */
export function MidiasLoteBar({ total, selecionadas, onTodas, onLimpar, onAplicar, onSair }) {
  const [data, setData] = useState("");
  const [busy, setBusy] = useState(false);
  const n = selecionadas.length;
  const run = async (body) => {
    setBusy(true);
    try { await onAplicar(body); } finally { setBusy(false); }
  };
  return (
    <div data-testid="midias-lote-bar" style={{
      position: "sticky", top: 72, zIndex: 40, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap",
      padding: "12px 16px", marginBottom: 16, background: "rgba(21,20,26,0.92)", backdropFilter: "blur(14px)",
      border: "1px solid var(--gold)", boxShadow: "0 8px 30px rgba(0,0,0,0.4)",
    }}>
      <CheckSquare size={14} color="#b8935a" />
      <strong style={{ fontSize: 13, color: "var(--ink)" }} data-testid="midias-lote-count">{n} selecionada(s)</strong>
      <button className="chip" onClick={n === total ? onLimpar : onTodas} data-testid="midias-lote-todas">{n === total ? "limpar" : `todas (${total})`}</button>
      <span style={{ width: 1, height: 22, background: "var(--line)" }} />
      <button className="chip" disabled={!n || busy} onClick={() => run({ obra_concluida: true })} data-testid="midias-lote-concluida" style={{ borderColor: "var(--gold)", color: "var(--gold)" }}>✓ marcar obra concluída</button>
      <button className="chip" disabled={!n || busy} onClick={() => run({ obra_concluida: false })} data-testid="midias-lote-desmarcar">desmarcar</button>
      <button className="chip" disabled={!n || busy} onClick={() => run({ antes_obra: true, obra_concluida: false })} data-testid="midias-lote-antes">antes da obra</button>
      <button className="chip" disabled={!n || busy} onClick={() => run({ antes_obra: false })} data-testid="midias-lote-desmarcar-antes">tirar "antes"</button>
      <span style={{ width: 1, height: 22, background: "var(--line)" }} />
      <input type="date" value={data} max={hojeBR()} onChange={e => setData(e.target.value)} data-testid="midias-lote-data"
        style={{ background: "var(--bg-1)", border: "1px solid var(--line)", color: "var(--ink)", padding: "4px 8px", fontSize: 12, colorScheme: "dark", width: 150 }} />
      <button className="chip" disabled={!n || !data || busy} onClick={() => run({ data_captura: data })} data-testid="midias-lote-aplicar-data">aplicar data</button>
      <div style={{ flex: 1 }} />
      <button className="chip" onClick={onSair} data-testid="midias-lote-sair"><X size={10} /> sair da seleção</button>
    </div>
  );
}

export const SelecaoCheck = ({ marcado, testid }) => (
  <div data-testid={testid} style={{
    position: "absolute", top: 10, right: 10, zIndex: 4, width: 24, height: 24, borderRadius: 4,
    border: `2px solid ${marcado ? "#b8935a" : "rgba(245,240,232,0.8)"}`, background: marcado ? "#b8935a" : "rgba(13,13,15,0.55)",
    display: "flex", alignItems: "center", justifyContent: "center", color: "#0d0d0f", fontWeight: 700, fontSize: 14, pointerEvents: "none",
  }}>{marcado ? "✓" : ""}</div>
);
